import React from 'react'

import { ContentEditable } from './ContentEditable'
import { ReadOnlyTag, TagRemove, TagWrapper } from './styled'

export class Tag extends React.Component {
  innerEditableRef = React.createRef()

  remove = () => this.props.remove(this.props.index)

  render() {
    const {
      invalidTag,
      value,
      index,
      editable,
      inputRef,
      validator,
      update,
      readOnly,
      removeOnBackspace,
      testId = '',
    } = this.props

    return (
      <TagWrapper data-testid={testId} invalid={invalidTag}>
        {!editable && <ReadOnlyTag>{value}</ReadOnlyTag>}
        {editable && (
          <ContentEditable
            value={value}
            inputRef={inputRef}
            innerEditableRef={this.innerEditableRef}
            change={(newValue) => update(index, newValue)}
            remove={this.remove}
            validator={validator}
            removeOnBackspace={removeOnBackspace}
          />
        )}
        <TagRemove
          data-testid="tag-remove"
          readOnly={readOnly}
          onClick={this.remove}
        />
      </TagWrapper>
    )
  }
}
